module.exports = __webpack_public_path__ + "static/img/2.ca13133.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/9/sp/2.png
// module id = xwNA
// module chunks = 0